<template>
  <v-app id="login"
         class="secondary">
    <v-content>
      <v-container fluid
                   fill-height>
        <v-layout align-center
                  justify-center>
          <v-flex xs12
                  sm8
                  md4
                  lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="@/assets/logo.png"
                       alt="Vue Material Admin"
                       width="180"
                       height="180" />
                  <h1 class="flex my-4 primary--text">四川持恒</h1>
                </div>
                <v-form :model="loginForm"
                        ref="loginForm"
                        @keyup.enter.native="handleLogin">
                  <v-text-field append-icon="fa fa-user"
                                name="login"
                                label="账户"
                                type="text"
                                v-model="loginForm.username"
                                :error="error"
                                :rules="[rules.required]" />
                  <v-text-field :type="hidePassword ? 'password' : 'text'"
                                :append-icon="hidePassword ? 'fa fa-eye' : 'fa fa-eye-slash'"
                                name="password"
                                label="密码"
                                id="password"
                                :rules="[rules.required]"
                                v-model="loginForm.password"
                                :error="error"
                                @click:append="hidePassword = !hidePassword" />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary"
                       @click="$router.push({ path: '/Main' })"
                       :loading="loading">取消</v-btn>
                <v-btn color="primary"
                       @keyup.enter="handleLogin"
                       @click="handleLogin"
                       :loading="loading">登录</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-snackbar v-model="showResult"
                  :timeout="2000"
                  color="red"
                  top>{{ result }}</v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
export default {
  props: {
    isLogin: {
      type: String,
      default: "0"
    }
  },
  data () {
    return {
      loading: false,
      loginForm: {
        username: 1,
        password: "1"
      },
      hidePassword: true,
      error: false,
      showResult: false,
      result: '',
      rules: {
        required: (value) => !!value || '不能为空'
      },
    }
  },
  methods: {
    showPwd () {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    handleLogin () {
      if (this.loginForm.username && this.loginForm.password) {
        this.loading = true;
        this.$store
          .dispatch("Login", this.loginForm)
          .then(response => {
            this.loading = false;
            let code = response.data.data;
            if (code == 200) {
              sessionStorage.clear()
              // 保存userId
              sessionStorage.setItem('userId', JSON.stringify(this.loginForm.username))
              //保存token
              sessionStorage['token'] = response.data.data2;
              sessionStorage["isLogin"] = JSON.stringify(1);
              //更新登录标识
              this.$emit("updateIsLogin").$nextTick(() => {
                this.$router.push({ path: "/NewsList" });
              })

            } else {
              if (code == 400) {
                this.result = "该账户已被禁用"
                this.showResult = true;
              } else {
                this.result = "账户或密码错误"
                this.showResult = true;
              }

            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.result = "账户或密码不能为空"
        this.showResult = true

      }
    },
  },
  directives: {
    focus: {
      // 当被绑定的元素插入到 DOM 中时……
      inserted: function (el) {
        // 聚焦元素
        el.focus();
      }
    },
  },
}

</script>

<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.primary {
  width: 50%;
  align-content: center;
}
</style>
